module.exports = __webpack_public_path__ + "static/9-formation-deformation-s-xii-ffa660770bed4999f3c6a7cdd86ebdb9.jpg";